import ActionsCrudConstructor from '~/store/utils/ActionsCrudConstructor';
import createReducer from '~/store/utils/createReducer';
import { takeLatest, all } from 'redux-saga/effects';
import {
  findRecordRequest,
  destroyRecordRequest,
  updateRecordRequest,
  createRecordRequest,
  fetchListRecordsRequest,
} from '~/services/fetchApi/customRecords';
import {
  initLoading,
  setErrors,
  resetState,
  fetchStart,
  fetchDone,
  setCurrent,
  setChangeList,
  fetchListStart,
  fetchListDone
} from '~/store/utils/reducerFns';
import { customRecordsRoute } from '~/routes'

/* =================================================
  REDUX TYPES
================================================= */
export const CUSTOM_RECORDS_SET_CURRENT = '@App/customRecords/CUSTOM_RECORDS_SET_CURRENT';
export const CUSTOM_RECORDS_FETCH_START = '@App/customRecords/CUSTOM_RECORDS_FETCH_START';
export const CUSTOM_RECORDS_FETCH_DONE  = '@App/customRecords/CUSTOM_RECORDS_FETCH_DONE';
export const CUSTOM_RECORDS_FETCH_LIST_START = '@App/customRecords/CUSTOM_RECORDS_FETCH_LIST_START';
export const CUSTOM_RECORDS_FETCH_LIST_DONE = '@App/customRecords/CUSTOM_RECORDS_FETCH_LIST_DONE';
export const CUSTOM_RECORDS_SET_ERRORS = '@App/customRecords/CUSTOM_RECORDS_SET_ERRORS';
export const CLEAR_STATE = '@App/customRecords/CLEAR_STATE';
export const FIND_CUSTOM_RECORD_REQUEST = '@App/customRecords/FIND_CUSTOM_RECORD_REQUEST';
export const DESTROY_CUSTOM_RECORDS_REQUEST = '@App/customRecords/DESTROY_CUSTOM_RECORDS_REQUEST';
export const UPDATE_CUSTOM_RECORDS_REQUEST = '@App/customRecords/UPDATE_CUSTOM_RECORDS_REQUEST';
export const CREATE_CUSTOM_RECORDS_REQUEST = '@App/customRecords/CREATE_CUSTOM_RECORDS_REQUEST';
export const FETCH_CUSTOM_RECORDS_REQUEST  = '@App/customRecords/FETCH_CUSTOM_RECORDS_REQUEST';
export const CUSTOM_RECORDS_CHANGE_LIST  = '@App/customRecords/CUSTOM_RECORDS_CHANGE_LIST';

/* =================================================
  REDUX REDUCER
================================================= */

const INITIAL_STATE = {
  current:   undefined,
  data:      [],
  errors:    [],
  isLoading: false,
  listIsLoading: false,
  totalData: 0,
};

export default createReducer(
  INITIAL_STATE,
  {
    [CLEAR_STATE]: resetState,
    [CUSTOM_RECORDS_FETCH_START]: fetchStart,
    [CUSTOM_RECORDS_FETCH_DONE]:  fetchDone,
    [CUSTOM_RECORDS_FETCH_LIST_START]: fetchListStart,
    [CUSTOM_RECORDS_FETCH_LIST_DONE]: fetchListDone,
    [CUSTOM_RECORDS_SET_ERRORS]: setErrors,
    [CUSTOM_RECORDS_SET_CURRENT]: setCurrent,
    [DESTROY_CUSTOM_RECORDS_REQUEST]: initLoading,
    [CREATE_CUSTOM_RECORDS_REQUEST]: initLoading,
    [UPDATE_CUSTOM_RECORDS_REQUEST]: initLoading,
    [CUSTOM_RECORDS_CHANGE_LIST]: setChangeList,
  }
)

/* =================================================
  REDUX ACTIONS
================================================= */
export function clearState() { return { type: CLEAR_STATE } } // Utilizado ao desmontar os componentes
export function findRecord(id, params={}) {
  return {
    type: FIND_CUSTOM_RECORD_REQUEST,
    payload: { id, params }
  }
}
export function destroyRecord(id, params={}, callbackSuccess) {
  return {
    type: DESTROY_CUSTOM_RECORDS_REQUEST,
    payload: { id, params, callbackSuccess }
  }
}

export function updateRecord(id, data, params={}, callbackSuccess=undefined, callbackFailed=undefined) {
  return {
    type: UPDATE_CUSTOM_RECORDS_REQUEST,
    payload: { id, data, params, callbackSuccess, callbackFailed }
  }
}
export function createRecord(data, params={}, callbackSuccess=undefined, callbackFailed=undefined) {
  return {
    type: CREATE_CUSTOM_RECORDS_REQUEST,
    payload: { data, params, callbackSuccess, callbackFailed }
  }
}

export function fetchRecords(params='', requestSource=undefined, callbackSuccess=undefined, callbackFailed=undefined) {
  return {
    type: FETCH_CUSTOM_RECORDS_REQUEST,
    payload: { params, requestSource, callbackSuccess, callbackFailed }
  }
}

/* =================================================
  SAGA ACTIONS
================================================= */
const crudActions = new ActionsCrudConstructor({
  reducerKey: 'customRecords',

  routes: {
    list: ({sys_key}) => customRecordsRoute.list.build({sys_key}),
    show: (id, {sys_key}) => customRecordsRoute.show.build({id, sys_key}),
    new: (id, {sys_key}) => customRecordsRoute.new.build({id, sys_key})
  },

  apiRequests: {
    findRecordApi:    findRecordRequest,
    destroyRecordApi: destroyRecordRequest,
    updateRecordApi:  updateRecordRequest,
    createRecordApi:  createRecordRequest,
    fetchListApi:     fetchListRecordsRequest,
  },

  actionTypes: {
    FETCH_START:     CUSTOM_RECORDS_FETCH_START,
    FETCH_DONE:       CUSTOM_RECORDS_FETCH_DONE,
    FETCH_LIST_START: CUSTOM_RECORDS_FETCH_LIST_START,
    FETCH_LIST_DONE:  CUSTOM_RECORDS_FETCH_LIST_DONE,
    CHANGE_LIST:      CUSTOM_RECORDS_CHANGE_LIST,
    CHANGE_CURRENT:   CUSTOM_RECORDS_SET_CURRENT,
    SET_ERRORS:       CUSTOM_RECORDS_SET_ERRORS,
  }
});

export const saga = all([
  takeLatest(FIND_CUSTOM_RECORD_REQUEST, crudActions.showAction),
  takeLatest(DESTROY_CUSTOM_RECORDS_REQUEST, crudActions.destroyAction),
  takeLatest(UPDATE_CUSTOM_RECORDS_REQUEST, crudActions.updateAction),
  takeLatest(CREATE_CUSTOM_RECORDS_REQUEST, crudActions.createAction),
  takeLatest(FETCH_CUSTOM_RECORDS_REQUEST, crudActions.fetchListAction),
]);